'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
var $d_Lcom_raquo_airstream_core_InternalObserver = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "com.raquo.airstream.core.InternalObserver", ({
  aj: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver as $d_Lcom_raquo_airstream_core_InternalObserver };
